import styled from "styled-components/macro";

export const Button = styled.a`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-weight: bold;
  color: ${(props) => (props.white ? "#08b21c" : "#fbfbfb")};
  background: ${(props) => (props.primary ? "#08B21C" : "transparent")};
  background: ${(props) => props.white && "#fbfbfb"};
  border: ${(props) =>
    props.white ? "4px solid #fbfbfb" : "4px solid #08b21c"};
  cursor: pointer;
  user-select: none;
  &:hover {
    background: #08b21c75;
    background: ${(props) => props.white && "#fbfbfb75"};
    color: ${(props) => props.white && "#fbfbfb"};
  }
  &:active {
    background: ${(props) => (props.primary ? "#08b21c00" : "#08b21c")};
    background: ${(props) => props.white && "#fbfbfb00"};
    color: ${(props) => props.white && "#fbfbfb"};
  }
`;
